import { type ButtonHTMLAttributes, forwardRef } from "react";
import { cn } from "@/shared/cn";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  size?: 32 | 36;
  tone?: "framed" | "plain";
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, size = 32, tone = "framed", className, children, type = "button", ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      title={label}
      className={cn(
        "inline-grid shrink-0 cursor-pointer place-items-center text-(--dim)",
        "transition-colors duration-(--duration-fast) [&_svg]:size-[16px]",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--brand)",
        "disabled:cursor-default disabled:opacity-45",
        tone === "framed"
          ? "rounded-[10px] border border-(--line-strong) bg-(--paper) hover:border-(--brand-line) hover:text-(--brand)"
          : "rounded-[8px] hover:bg-(--fill) hover:text-(--ink)",
        size === 36 ? "size-[36px] rounded-[11px]" : "size-[32px]",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
});
